import React from "react";
import "./printCss.css";
import guamLogo from "../../../../../assets/GuamSeal.svg";
import guamLogo2 from "../../../../../assets/GuamLogo.png";
import { Col, Row } from "reactstrap";
import moment from "moment";
import AmendmentPrint from "./AmendmentPrint";
import CancelCloseAnnouncePrint from "./CancelCloseAnnouncePrint";

const DemoPrint = () => {
  let data = {};
  let requirement = {};
  return (
    <>
    <div style={{display:"none"}}>
        <AmendmentPrint />
      </div>
      <div>
        <CancelCloseAnnouncePrint />
      </div>

      <div
        style={{ padding: "10px", pageBreakBefore: "always", display: "none" }}
      >
        <div style={{ display: "flex" }}>
          <div style={{ width: "30%", textAlign: "left" }}>
            <span
              style={{
                float: "left",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <img src={guamLogo2} alt="Logo 1" style={{ height: "60px" }} />
              <p className="tophead">EDWARD M. BIRN</p>
              <p className="tophead">Director (Direktot)</p>
              <p className="tophead">ELIZABETH T. FISHER</p>
              <p className="tophead">Deputy Director (Sigundo Direktot)</p>
            </span>
          </div>
          <div style={{ width: "40%", textAlign: "center" }}>
            <div style={{ display: "inline-block", color: "green    " }}>
              <h1
                className="admin1"
                style={{ fontSize: "24px", fontWeight: "700" }}
              >
                DEPARTMENT OF ADMINISTRATION
              </h1>
              <h3 className="admin1" style={{ fontSize: "16px" }}>
                DIPATTAMENTON AMETNESTRASYON
              </h3>
              <h4
                className="admin1"
                style={{ fontSize: "13px", fontWeight: "700" }}
              >
                HUMAN RESOURCES DIVISION
              </h4>
              <h3
                className="admin1"
                style={{ fontSize: "13px", fontWeight: "600" }}
              >
                (Dibision Inadilanto yan Guinaha Para Taotao)
              </h3>
              <h6
                className="tophead"
                style={{ fontSize: "12px", fontStyle: "italic" }}
              >
                Telephone (Telifon): (671) 475-1288/1103 . Fax (Faks): (671)
                477-3671
              </h6>
            </div>
          </div>
          <div style={{ width: "30%", textAlign: "right" }}>
            <span
              style={{
                float: "right",
                display: "flex",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <img src={guamLogo} alt="Logo 2" style={{ height: "60px" }} />
              <p className="tophead">LOURDES A. LEON GUERRERO</p>
              <p className="tophead">Governor (Maga’håga)</p>
              <p className="tophead">JOSHUA F. TENORIO</p>
              <p className="tophead">Lt. Governor (Sigundo Maga’låhi)</p>
            </span>
          </div>
        </div>
        <div className="examination">
          <h2 className="examination1" style={{ fontSize: "24px" }}>
            OPEN COMPETITIVE EXAMINATION
          </h2>
          <div className="examination2">
            <div className="maincontent">
              <div className="examination2-content">
                <div className="cont-1">
                  To establish a list for the position of
                </div>
                <h1
                  className="cont-2"
                  style={{ fontSize: "24px", fontWeight: "600" }}
                >
                  {data?.positionTitle}
                </h1>
                <div className="cont-3">
                  <h4 style={{ fontSize: "16px" }}>Announcement Number :</h4>
                  <div>{data?.announcementId}</div>
                </div>
                <div className="cont-4">
                  <div className="open1">
                    <h4 style={{ fontSize: "16px" }}>Open : &nbsp;</h4>
                    <div>
                      {data?.dateEntered
                        ? moment(data?.datePosted).format("MM-DD-YYYY")
                        : null}
                    </div>
                    &nbsp;
                  </div>
                  <div className="open2">
                    <h4 style={{ fontSize: "16px" }}>Close :&nbsp;</h4>
                    <div>
                      {data?.dateEntered
                        ? moment(data?.dateClosed).format("MM-DD-YYYY")
                        : null}
                    </div>
                  </div>
                </div>
                <div className="cont-5">
                  <h4 style={{ fontSize: "16px" }}>GENERAL PAY PLAN (GPP)</h4>
                  <span>
                    OPEN: {data?.grade}-{data?.step}; ${data?.salary} P/A
                  </span>
                  {/* <div>PROMOTION: G-01; $30,169 P/A –G-18; $53,174 P/A</div> */}
                </div>
                <div className="cont-6">
                  <p>
                    The Government of Guam may offer competitive benefit
                    packages, which includes retirement (Defined Contribution
                    Plan 401 and 457), health insurance plans, cafeteria plan,
                    an Employee Assistance Program, annual and sick leave, paid
                    holidays and life insurance. For additional information
                    regarding the Government of Guam Retirement, please visit
                    www.ggrf.com.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="contentlist">
          {requirement?.WhoCanApply ? (
            <div className="apply">
              <h4>Who Can Apply</h4>
              <p>{requirement?.WhoCanApply}</p>
            </div>
          ) : null}
          {requirement?.QualificationRequirement ? (
            <div className="apply">
              <h4>Qualification Requirements</h4>
              <p>{requirement?.QualificationRequirement}</p>
            </div>
          ) : null}
          {requirement?.NatureofWork ? (
            <div className="apply">
              <h4>Nature of work</h4>
              <p>{requirement?.NatureofWork}</p>
            </div>
          ) : null}
          {requirement?.illustrativeExofWork ? (
            <div className="apply">
              <h4>Illustrative Examples of Work</h4>
              <p>{requirement?.illustrativeExofWork}</p>
            </div>
          ) : null}
          {requirement?.KnowledgeAbilitiesSkills ? (
            <div className="apply">
              <h4>Knowledge, Abilities & Skills</h4>
              <p style={{ border: "none" }}>
                {requirement?.KnowledgeAbilitiesSkills}
              </p>
            </div>
          ) : null}
          {requirement?.MinimumEducationReq ? (
            <div className="apply">
              <h4>Minimum Educational Requirements</h4>
              <p>{requirement?.MinimumEducationReq}</p>
            </div>
          ) : null}
          {requirement?.DocRequirement ? (
            <div className="apply">
              <h4>Documentation Requirements</h4>
              <p>{requirement?.DocRequirement}</p>
            </div>
          ) : null}
          {requirement?.SuitabilityDeterminationForm ? (
            <div className="apply">
              <h4>Suitability Determination Form</h4>
              <p>{requirement?.SuitabilityDeterminationForm}</p>
            </div>
          ) : null}
          {requirement?.ProhibitionPursuant ? (
            <div className="apply">
              <h4>Prohibition Pursuant to P.L. 28-98</h4>
              <p>{requirement?.ProhibitionPursuant}</p>
            </div>
          ) : null}
        </div>
        <div style={{ pageBreakBefore: "always", marginTop: "20px" }}></div>
        <div className="treasury">
          <h4 style={{ fontSize: "24px" }}> {data?.positionTitle}</h4>
          <h5>OPEN COMPETITIVE EXAMINATION</h5>
        </div>
        <div className="contentlist">
          {requirement?.ExaminationReq ? (
            <div className="apply">
              <h4>Examination Requirements</h4>
              <p>{requirement?.ExaminationReq}</p>
            </div>
          ) : null}
          {requirement?.InterviewProcedures ? (
            <div className="apply">
              <h4>Interviewing Procedures</h4>
              <p>{requirement?.InterviewProcedures}</p>
            </div>
          ) : null}
          {requirement?.EmploymentMedicalExamination ? (
            <div className="apply">
              <h4>Employment Medical Examination</h4>
              <p>{requirement?.EmploymentMedicalExamination}</p>
            </div>
          ) : null}
          {requirement?.WorkEligibility ? (
            <div className="apply">
              <h4>Work Eligibility</h4>
              <p>{requirement?.WorkEligibility}</p>
            </div>
          ) : null}
          {requirement?.DrugScreening ? (
            <div className="apply">
              <h4>Drug Screening</h4>
              <p>{requirement?.DrugScreening}</p>
            </div>
          ) : null}
          {requirement?.PoliceCourtClearances ? (
            <div className="apply">
              <h4>Police & Court Clearances Requirements I</h4>
              <p>{requirement?.PoliceCourtClearances}</p>
            </div>
          ) : null}
          {requirement?.WhereToApply ? (
            <div className="apply">
              <h4>Where to Apply</h4>
              <p>{requirement?.WhereToApply}</p>
            </div>
          ) : null}
          {requirement?.ForMoreInfo ? (
            <div className="apply">
              <h4>For More Information</h4>
              <p>{requirement?.ForMoreInfo}</p>
            </div>
          ) : null}
        </div>
        {/* <div className="sig">
      <h4> SHANE G.L. NGATA</h4>
      <span>PERSONNEL SERVICES ADMINISTRATOR</span>
      <p>HUMAN RESOURCES DIVISION</p>
    </div> */}
        <Row style={{ marginTop: "100px" }}>
          <Col sm={4}></Col>
          <Col sm={4}>
            <div style={{ borderBottom: "1px solid black" }}></div>
            <div style={{ fontSize: "14px", textAlign: "center" }}>
              Appointing Authority
            </div>
          </Col>
          <Col sm={4}></Col>
        </Row>

        <Row style={{ marginTop: "40px" }}>
          <Col sm={12}>
            {/* <b> */}
            WE ARE AN EQUAL EMPLOYMENT OPPORTUNITY EMPLOYER. WE DO NOT
            DISCRIMINATE ON THE BASIS OF RACE, RELIGION, COLOR, SEX, AGE,
            DISABILITY, EXCEPT FOR POSITIONS REQUIRING BONA FIDE OCCUPATIONAL
            QUALIFICATION.
            {/* </b> */}
          </Col>
        </Row>
      </div>
    </>
  );
};

export default DemoPrint;
